import React, { useMemo } from 'react';
import { getComponentCssVariables } from '@wix/tpa-style-webpack-plugin/standalone';
export const FormTheme = _ref => {
  let {
    style,
    children,
    isMobile
  } = _ref;
  const validStylesheet = style && style.styleParams && style.siteTextPresets && style.siteColors;
  const cssVars = useMemo(() => validStylesheet && getComponentCssVariables(style, {}, {}, {
    isMobile
  }, {}), [validStylesheet, style, isMobile]);
  if (!validStylesheet || !cssVars) {
    return /*#__PURE__*/React.createElement("div", null, children);
  }
  return /*#__PURE__*/React.createElement("div", {
    style: cssVars.variables
  }, children);
};
//# sourceMappingURL=form-theme.js.map